import { CONVERSION_MODE } from '@/constants';

const { skip } = CONVERSION_MODE;

export const actionPhrase = (mode) =>
  mode === skip ? 'will be skipped' : 'will be synced with any new changes';

export const buildContext = (sourceIds, total, priorCount) => {
  // Selection types (account-sel, profile-sel) — total = sourceIds.length
  if (total) {
    if (priorCount === total) {
      return total === 1
        ? 'The selected playlist is already converted'
        : 'All selected playlists are already converted';
    }

    return `${priorCount} of ${total} selected playlists are already converted`;
  }

  // Single converter (one pasted URL)
  if (sourceIds.length === 1) {
    return 'This playlist is already converted';
  }

  // Account/profile all-mode (whole-account transfer)
  const label = priorCount === 1 ? 'playlist is' : 'playlists are';

  return `${priorCount} ${label} already converted`;
};

export const buildSkipAllMessage = (sourceIds, total) => {
  const lead = total
    ? total === 1
      ? 'The selected playlist is already converted'
      : 'All selected playlists are already converted'
    : 'This playlist is already converted';

  return `${lead}. Switch to SYNC above to apply any new changes.`;
};
